import React, { useState, useEffect, useRef, useContext } from "react";

import { Container, Nav, Navbar } from "react-bootstrap";
import { NavLink, Route, Switch, useRouteMatch } from "react-router-dom";

import "../../components/CSS/Profile/starProfile/starProfile.css";

import Souviner from "../../components/StarProfile/Auction";
import StarPhotos from "../../components/StarProfile/StarPhotos";
import Videos from "../../components/StarProfile/Videos";
import SouvenirRegister from "../../components/StarShowcase/Souvenir/SouvenirRegister";
import GreetingsPayContent from "../../components/StarProfile/GreetingsPay/GreetingsPayContent";
import GreetingsRegistrationForm from "../../components/Layouts/Header/NotificationDropdownModal/RegisterGreetings/RegisterGreetings";
import BookNowEvent from "../../components/StarProfile/BookNow/BookNowEvent";

import LiveChat from "../../components/StarProfile/LiveChat/LiveChat";
import Meetup from "../../components/StarProfile/Meetup/Meetup";
import StarChat from "../../components/StarProfile/StarChat/StarChat";
import Greeting from "../../components/StarProfile/StarChat/starGreeeting/Greeting";

import SkeletonArticle from "../../components/Post_skaliton/SkeletonArticle";
import PostContent from "../Post/PostContent";

import axios from "axios";
import StarProfileRightContent from "../../components/StarProfile/StarCardComponent/StarProfileRightContent/StarProfileRightContent";
import QAInstractions from "../../components/Pages/QuestionandAnswer/QAInstractions";
import QARegister from "../../components/Pages/QuestionandAnswer/QARegister";
import noImage from "../../Assets/Images/Desert-Nights.jpg";
import Learning from "../../components/StarProfile/Learning/Learning";
import StarAuction from "../../components/StarProfile/StarAuction";

import StarMarketPlace from "../../components/StarProfile/StarMarketPlace";
import FanGroupPost from "../../components/StarProfile/FanGruopPost";
import InfiniteScroll from "react-infinite-scroll-component";
import Navigation from "../../components/Layouts/Header/Navigation";
import "./Profile.css";
import "../../components/CSS/Profile/starProfile/starPhotos.css";
import "../../components/CSS/Profile/starProfile/starPost.css";
import "../../components/CSS/Profile/starProfile/starPhotosDetails.css";
import "../../components/CSS/Profile/starProfile/starVideoDetails.css";
import "../../components/CSS/Profile/starProfile/starChat.css";
import Audition from "../../components/StarProfile/Audition/Audition";
import NodataAvailable from "../../components/Common/NodataAvailable";
import DogWithBoll from "../../Assets/Images/dogwithball.gif";
import { serverInfo } from "../../App";
import BootstrapSwitchButton from 'bootstrap-switch-button-react'
import StarQna from "../../components/StarProfile/Qna/StarQna";
import StarFangroup from "../../components/StarProfile/Fangroup/StarFangroup";
const StarProfile = (props) => {

  const { imageCdnUrl } = useContext(serverInfo);

  const star_id = props.match.params.star_id;
  let { path, url } = useRouteMatch();
  const [star, setStar] = useState({});
  const [posts, setPosts] = useState([]);
  const [status, setstatus] = useState(true);
  const [openMessenger, setOpenMessenger] = React.useState(false);
  const [paginate, setPaginate] = useState(1);
  const [loader, setLoader] = useState(true);

  const [isFollow, setIsFollow] = useState();

  useEffect(() => {
    let isMounted = true;

    axios.get(`/api/star_info/${star_id}`).then((res) => {
      if (isMounted) {
        if (res.data.status === 200) {
          setStar(res.data.star);
        }
      }
    });

    axios.get(`/api/user/star/follow-unfollow/check/${star_id}`).then((res) => {

      if (res.data.status === 200) {
        setIsFollow(res.data.isFollow);

      }
    });

    fetchData();

  }, []);

  const fetchData = () => {
    axios
      .get(
        `/api/user/getStarPost/${star_id}/all/with-paginate/5?page=${paginate}`
      )
      .then((res) => {
        if (res.status === 200) {
          setPosts([...posts, ...res.data.posts]);
          setPaginate(paginate + 1);
          setstatus(false);
          setLoader(false)
        }
      });
  };
  function handleFollow() {
    const formData = new FormData();

    formData.append("star_id", star_id);

    axios
      .post(`/api/user/selected/starcategory/store`, formData)
      .then((res) => {
        if (res.status === 200) {
          setLoader(false)
        }
      });
  }


  return (
    <>
      <Navigation />
      <div className="full-container py-3">
        <div className="container star-cover mb-2">
          <div className="profile-img-cover ">
            <div className="profile-container ">
              {star?.cover_photo ? (
                <img
                  src={imageCdnUrl + star?.cover_photo}
                  alt="bg-img"
                  className="img-fluid profile-cover"
                />
              ) : (
                <img
                  src={noImage}
                  alt="bg-img"
                  className="img-fluid profile-cover"
                />
              )}

              <div className="star-profile-pic d-flex align-items-center">
                <img
                  src={
                    star?.image ? imageCdnUrl + star?.image
                      : noImage
                  }
                  alt=""
                  className="img-fluid profile-star "
                />
                <div className="  mx-2">
                  <div className="text-light star-profile-name">
                    {star?.first_name} {star?.last_name}
                  </div>


                  {star.username ? (
                    <small className="text-warning star-profile-type">
                      @{star.username}
                    </small>
                  ) : (
                    <small className="text-warning star-profile-type mb-2">
                      @username
                    </small>
                  )}
                  {!loader &&
                    <div>
                      <BootstrapSwitchButton checked={isFollow} size="sm" onChange={handleFollow} onlabel="Following" offlabel="Follow" width={100} onstyle="outline-warning" offstyle="outline-info" />
                    </div>}


                </div>

              </div>

            </div>
            <div className="container next-div">

              {/* <div className="line-div my-1"></div> */}
              <div>
                <Navbar className="sticky-profile-nav">
                  <Container>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                      <Nav className="mx-auto d-flex flex-wrap">
                        <button className="BtnLT buttonStyleProfile">
                          <NavLink
                            to={`${url}/post`}
                            className="text-decoration-none responsiveText
                            "
                            style={(isActive) => ({
                              color: isActive ? "#ffad00" : "white",
                            })}
                          >
                            All Post
                          </NavLink>
                        </button>

                        <button className="BtnLT buttonStyleProfile">
                          <NavLink
                            to={`${url}/photos`}
                            className="mx-2 text-decoration-none responsiveText"
                            style={(isActive) => ({
                              color: isActive ? "#ffad00" : "white",
                            })}
                          >
                            Photos
                          </NavLink>
                        </button>

                        <button className="BtnLT buttonStyleProfile ">
                          <NavLink
                            to={`${url}/videos`}
                            className="mx-2 text-decoration-none responsiveText"
                            style={(isActive) => ({
                              color: isActive ? "#ffad00" : "white",
                            })}
                          >
                            Videos
                          </NavLink>
                        </button>

                        <button className="BtnLT buttonStyleProfile">
                          <NavLink
                            to={`${url}/fan-group-post`}
                            className="mx-2 text-decoration-none responsiveText"
                            style={(isActive) => ({
                              color: isActive ? "#ffad00" : "white",
                            })}
                          >
                            Fan Group
                          </NavLink>
                        </button>

                        <div className="MobileNa">
                          <button className="BtnLTr me-2">
                            <NavLink
                              to={`${url}/post`}
                              className="mx-2 text-decoration-none "
                              style={(isActive) => ({
                                color: isActive ? "#ffad00" : "white",
                              })}
                            >

                              All Post
                            </NavLink>
                          </button>

                          <button className="BtnLTr me-2">
                            <NavLink
                              to={`${url}/photos`}
                              className="mx-2 text-decoration-none "
                              style={(isActive) => ({
                                color: isActive ? "#ffad00" : "white",
                              })}
                            >
                              Photos
                            </NavLink>
                          </button>

                          <button className="BtnLTr me-2">
                            <NavLink
                              to={`${url}/videos`}
                              className="mx-2 text-decoration-none "
                              style={(isActive) => ({
                                color: isActive ? "#ffad00" : "white",
                              })}
                            >
                              Videos
                            </NavLink>
                          </button>

                          <button className="BtnLTr me-2">
                            <NavLink
                              to={`${url}/fan-group-post`}
                              className="mx-2 text-decoration-none "
                              style={(isActive) => ({
                                color: isActive ? "#ffad00" : "white",
                              })}
                            >
                              Fan Group
                            </NavLink>
                          </button>

                          <button className="BtnLTr me-2">
                            <NavLink
                              to={`/starprofile/${star_id}/greeting`}
                              className="mx-2 text-decoration-none "
                              style={(isActive) => ({
                                color: isActive ? "#ffad00" : "white",
                              })}
                            >

                              Greetings
                            </NavLink>
                          </button>

                          <button className="BtnLTr me-2">
                            <NavLink
                              to={`/starprofile/${star_id}/livechat`}
                              className="mx-2 text-decoration-none "
                              style={(isActive) => ({
                                color: isActive ? "#ffad00" : "white",
                              })}
                            >

                              Live Chat
                            </NavLink>
                          </button>

                          <button className="BtnLTr me-2">
                            <NavLink
                              to={`/starprofile/${star_id}/qna`}
                              className="mx-2 text-decoration-none "
                              style={(isActive) => ({
                                color: isActive ? "#ffad00" : "white",
                              })}
                            >

                              Q & A
                            </NavLink>
                          </button>

                          <button className="BtnLTr me-2">
                            <NavLink
                              to={`/starprofile/${star_id}/meetup`}
                              className="mx-2 text-decoration-none "
                              style={(isActive) => ({
                                color: isActive ? "#ffad00" : "white",
                              })}
                            >
                              Meetup
                            </NavLink>
                          </button>

                          {/* <button className="BtnLTr me-2">
                            <NavLink
                              to={`/starprofile/${star_id}/meetup`}
                              className="mx-2 text-decoration-none "
                              style={(isActive) => ({
                                color: isActive ? "#ffad00" : "white",
                              })}>Auddition
                              </NavLink>
                            </button> */}

                          <button className="BtnLTr me-2">
                            <NavLink
                              to={`/starprofile/${star_id}/learning`}
                              className="mx-2 text-decoration-none "
                              style={(isActive) => ({
                                color: isActive ? "#ffad00" : "white",
                              })}
                            >
                              Learning
                            </NavLink>
                          </button>

                          <button className="BtnLTr me-2">
                            <NavLink
                              to={`/starprofile/${star_id}/star-marketplace`}
                              className="mx-2 text-decoration-none "
                              style={(isActive) => ({
                                color: isActive ? "#ffad00" : "white",
                              })}
                            >
                              Marketplace
                            </NavLink>
                          </button>

                          <button className="BtnLTr me-2">
                            <NavLink
                              to={`/starprofile/${star_id}/star-auction`}
                              className="mx-2 text-decoration-none "
                              style={(isActive) => ({
                                color: isActive ? "#ffad00" : "white",
                              })}
                            >
                              Auction
                            </NavLink>
                          </button>

                          <button className="BtnLTr me-2">
                            <NavLink
                              to={`/starprofile/${star_id}/souvenir`}
                              className="mx-2 text-decoration-none "
                              style={(isActive) => ({
                                color: isActive ? "#ffad00" : "white",
                              })}
                            >
                              Souvenir
                            </NavLink>
                          </button>
                        </div>
                      </Nav>
                    </Navbar.Collapse>
                  </Container>
                </Navbar>

                {/* work in progress */}
                <Switch>
                  {/* <Route path={`${path}/post/livechat`} exact component={LiveChat} /> */}
                  {/* <Route path={`${path}/:id/livechat`} exact component={LiveChat} /> */}

                  <Route
                    path={`${path}/:id/livechat/starChat`}
                    exact
                    component={StarChat}
                  />
                  <Route
                    path={`${path}/livechat/starChat`}
                    exact
                    component={StarChat}
                  />

                  {/* greeting routing start*/}

                  {/* <Route exact path={`${path}/:id/greeting`} component={Greeting} /> */}
                  <Route
                    path={`${path}/user-greetings-pay`}
                    exact
                    component={GreetingsPayContent}
                  />
                  {/* greeting routing end*/}

                  {/* <Route path={`${path}/book-now`} exact component={BookNowEvent} /> */}

                  <Route
                    path={`${path}/meetup-events/book_now/:id`}
                    exact
                    component={BookNowEvent}
                  />

                  <Route exact path={path}>
                    <div className="container StarContainer">
                      <div className="row">
                        <div className="col-sm-12 col-lg-8">
                          {status &&
                            [1, 2, 3, 4].map((valu) => (
                              <SkeletonArticle theme="dark" />
                            ))}

                          <InfiniteScroll
                            dataLength={posts.length}
                            next={fetchData}
                            hasMore={true}
                            loader={<i className="fas fa-spinner fa-pulse"></i>}
                            endMessage={
                              <p style={{ textAlign: "center" }}>
                                <b>You have seen it all</b>
                              </p>
                            }
                          >
                            {posts &&
                              posts.map((data) => (
                                <PostContent key={data.id} post={data} />
                              ))}
                          </InfiniteScroll>
                        </div>

                        <div className="col-md-4">
                          <StarProfileRightContent
                            openMessenger={openMessenger}
                            setOpenMessenger={setOpenMessenger}
                            star_id={star_id}
                          />
                        </div>
                      </div>
                    </div>
                  </Route>

                  <Route exact path={`${path}/souvenir`}>

                    <SouvenirRegister star_id={star_id} />
                  </Route>

                  <Route path={`${path}/post`}>
                    <div className="container StarContainer">
                      <div className="row StarRow">
                        <div className="col-sm-12 col-lg-8 TabeStar">
                          {status &&
                            [1, 2, 3, 4].map((valu) => (
                              <SkeletonArticle theme="dark" />
                            ))}

                          {posts.length > 0 ? (
                            posts.map((data) => (
                              <PostContent key={data.id} post={data} />
                            ))
                          ) : (
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <img
                                src={DogWithBoll}
                                style={{ height: 250, width: 500 }}
                              />
                              <h4 className="text-center text-warning">
                                No activity found yet
                              </h4>
                            </div>
                          )}
                        </div>

                        <div className="col-md-4">
                          <StarProfileRightContent star_id={star_id} />
                        </div>
                      </div>
                    </div>
                  </Route>

                  <Route path={`${path}/photos`}>
                    <StarPhotos star_id={star_id} />
                  </Route>
                  <Route path={`${path}/videos`}>

                    <Videos star_id={star_id} />
                  </Route>
                  <Route path={`${path}/souviner`}>

                    <Souviner star_id={star_id} />
                  </Route>
                  <Route path={`${path}/audition`}>

                    <Audition star_id={star_id} />
                  </Route>
                  <Route path={`${path}/greetings_registration_form`}>

                    <GreetingsRegistrationForm star_id={star_id} />
                  </Route>
                  {/* <Route path={`${path}/booking`}>
                    
                    <Audition star_id={star_id} />
                  </Route> */}
                  <Route path={`${path}/livechat`} exact>
                    <LiveChat star_id={star_id} />
                  </Route>
                  <Route path={`${path}/qna`} exact>
                    <StarQna star_id={star_id} />
                  </Route>
                  <Route path={`${path}/meetup`} exact>
                    <Meetup star_id={star_id} />
                  </Route>
                  <Route path={`${path}/learning`} exact>
                    <Learning star_id={star_id} />
                  </Route>
                  <Route path={`${path}/audition`} exact>
                    <Audition star_id={star_id} />
                  </Route>
                  <Route exact path={`${path}/greeting`}>

                    <Greeting star_id={star_id} />
                  </Route>
                  {/* <Route exact path={`${path}/qna`}>
                    
                    <QAInstractions star_id={star_id} />
                  </Route>
                  <Route exact path={`${path}/qa/register`}>
                    
                    <QARegister star_id={star_id} />
                  </Route> */}

                  <Route path={`${path}/photos`}>
                    <StarPhotos star_id={star_id} />
                  </Route>
                  <Route path={`${path}/videos`}>

                    <Videos star_id={star_id} />
                  </Route>
                  <Route path={`${path}/star-auction`}>

                    <StarAuction star_id={star_id} />
                  </Route>
                  <Route path={`${path}/audition`}>

                    <Audition star_id={star_id} />
                  </Route>
                  <Route path={`${path}/greetings_registration_form`}>

                    <GreetingsRegistrationForm star_id={star_id} />
                  </Route>
                  {/* <Route path={`${path}/booking`}>
                    
                    <Audition star_id={star_id} />
                  </Route> */}
                  <Route path={`${path}/livechat`} exact>
                    <LiveChat star_id={star_id} />
                  </Route>
                  <Route exact path={`${path}/greeting`}>

                    <Greeting star_id={star_id} />
                  </Route>
                  <Route exact path={`${path}/qna`}>

                    <QAInstractions star_id={star_id} />
                  </Route>
                  <Route exact path={`${path}/qa/register`}>

                    <QARegister star_id={star_id} />
                  </Route>

                  <Route exact path={`${path}/star-auction`}>

                    <StarAuction star_id={star_id} />
                  </Route>

                  <Route exact path={`${path}/star-marketplace`}>

                    <StarMarketPlace star_id={star_id} />
                  </Route>

                  <Route exact path={`${path}/fan-group-post`}>

                    <StarFangroup star_id={star_id} />
                  </Route>
                </Switch>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StarProfile;
